var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2648 14.9589C36.2294 15.4719 37.0363 16.2376 37.599 17.1741C38.1616 18.1107 38.4589 19.1826 38.4589 20.2752C38.4589 21.3677 38.1616 22.4397 37.599 23.3762C37.0363 24.3127 36.2294 25.0785 35.2648 25.5914L9.53299 39.584C5.38964 41.8395 0.300323 38.9072 0.300323 34.2698V6.28256C0.300323 1.64313 5.38964 -1.28714 9.53299 0.964286L35.2648 14.9589Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.0bbded8cf24f2f4440cc3ae798438e58.svg";
export { ForwardRef as ReactComponent };